import { ErrorCategory, ErrorSeverity, IErrorDescription } from '@ibank-globals/error';

export enum SourceApis {
	Identity = 0,
	Onboarding = 1,
}

export class ErrorDescription implements IErrorDescription {
	public id?: string;
	public code?: string;
	public desc?: string;
	public sev?: ErrorSeverity;
	public cat?: ErrorCategory;
	public type?: string;
	public canRefresh?: boolean;
	public sourceApi: SourceApis;

	// Optional modal display overrides — when set, the centralized error handler
	// renders the new redesigned modal instead of the legacy one.
	public modalTitle?: string;
	public modalMessage?: string;
	public modalIcon?: string;
	public modalAction?: string;

	public get hasModalOverrides(): boolean {
		return !!(this.modalTitle || this.modalMessage);
	}

	constructor(sourceApi: SourceApis, error?: IErrorDescription) {
		let newErrr: IErrorDescription = error || {
			id: null,
			desc: null,
		};

		this.read(newErrr, sourceApi);
	}

	private read(error: IErrorDescription, sourceApi: SourceApis): void {
		this.id = error.id;
		this.code = error.code;
		this.desc = error.desc;
		this.sev = error.sev;
		this.cat = error.cat;
		this.type = error.type;
		this.canRefresh = error.canRefresh;
		this.sourceApi = sourceApi;

		// Carry through modal display overrides if present
		const src = error as any;
		this.modalTitle = src.modalTitle;
		this.modalMessage = src.modalMessage;
		this.modalIcon = src.modalIcon;
		this.modalAction = src.modalAction;
	}
}
